export const MODALS = {
  otp: 0,
  scanParcel: 1,
  errorCod: 2,
  confirmCod: 3,
  handoverComplete: 4
}
